module.exports = __webpack_public_path__ + "img/jiejue_fangan.694f6d4.png";